// TOP LEVEL IMPORTS
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
// ANTD
import Timeline from 'antd/lib/timeline';
// APOLLO
import { graphql, compose } from 'react-apollo';
import getOrganizationTransactionsQuery from 'ApolloClient/Queries/getOrganizationTransactions';
// MODULES
import getTextAndColor from './getTextAndColor';
import ActivityAreaContainer from './ActivityAreaContainer';
// LIB
import RecomposeHelpers from 'lib/helpers/RecomposeHelpers';
//------------------------------------------------------------------------------
// COMPONENT:
//------------------------------------------------------------------------------
const OrganizationTransactions = props => {
  const { loading, getOrganizationTransactions } = props.getOrganizationTransactionsQuery;

  //   if (loading) {
  //     return (
  //       <ActivityAreaContainer loading={loading}>
  //         <span />
  //       </ActivityAreaContainer>
  //     );
  //   }

  // check if the array exists
  if (!getOrganizationTransactions || !getOrganizationTransactions.length || getOrganizationTransactions.length === 0) {
    return null;
  }

  return (
    <ActivityAreaContainer>
      {getOrganizationTransactions.map(t => {
        const { text, color, dot } = getTextAndColor(t);
        if (!text || !color) {
          return null;
        }
        return (
          <Timeline.Item key={t._id} color={color} dot={dot}>
            {text}
          </Timeline.Item>
        );
      })}
    </ActivityAreaContainer>
  );
};

//------------------------------------------------------------------------------
// PROP TYPES:
//------------------------------------------------------------------------------
OrganizationTransactions.propTypes = {
  /* data: PropTypes.shape({
    error: PropTypes.object,
    loading: PropTypes.bool.isRequired,
    getOrganizationTransactions: PropTypes.array,
  }).isRequired, */
};

//------------------------------------------------------------------------------
// APOLLO:
//------------------------------------------------------------------------------
const enhance = compose(
  withRouter,
  graphql(getOrganizationTransactionsQuery, {
    name: 'getOrganizationTransactionsQuery',
    options: {
      pollInterval: 60000,
    },
  }),
  RecomposeHelpers.errorHOC({ propName: 'getOrganizationTransactionsQuery' }),
  RecomposeHelpers.loadingHOC({ propName: 'getOrganizationTransactionsQuery' }),
);

//------------------------------------------------------------------------------
// EXPORTED COMPONENT:
//------------------------------------------------------------------------------
export default enhance(OrganizationTransactions);



// WEBPACK FOOTER //
// ./src/routes/app-home/OrganizationTransactions/index.js